import { render, staticRenderFns } from "./ticketDetailDrawer.vue?vue&type=template&id=70fa02d1&scoped=true"
import script from "./ticketDetailDrawer.vue?vue&type=script&lang=js"
export * from "./ticketDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./ticketDetailDrawer.vue?vue&type=style&index=0&id=70fa02d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa02d1",
  null
  
)

export default component.exports